export { onClickOutsideHOC } from './onClickOutsideDecorator';
